/*
 * $Id:: theme.js 2020/11/12 06:07 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

const theme = {
    breakpoints: {
        keys: ['xs', 'sm', 'md', 'lg', 'xl'],
        values: {
            xs: 0,
            sm: 600,
            md: 960,
            lg: 1280,
            xl: 1920,
        },
    },
    direction: 'ltr',
    mixins: {
        toolbar: {
            minHeight: 56,
            '@media (min-width:0px) and (orientation: landscape)': {
                minHeight: 48,
            },
            '@media (min-width:600px)': {
                minHeight: 64,
            },
        },
    },
    palette: {
        common: {
            black: '#000',
            white: '#fff',
        },
        type: 'light',
        primary: {
            main: '#5171c2',
            superLightGrey: '#f9f9f9', // dialog: actions/title bg, Buttons: contained bg
            grey: '#565656', // dialog: title color
            noneBackground: 'rgba(0,0,0,0)',
            infoBlue: 'rgba(0,106,170,0.1)',
        },
        disabled: {
            main: '#AAAAAA',
        },
        icon: {
            main: '#8d8d8d',
        },
        error: {
            main: '#e30d0d',
            // dialog: title bg (pastel colors)
            errorPink: 'rgba(227,13,13,0.1)',
        },
        success: {
            main: '#468a26',
            // dialog: title bg (pastel colors)
            successLightGreen: 'rgba(36,162,73,0.1)',
        },
        warning: {
            main: '#f08128',
            // dialog: title bg (pastel colors)
            warningLightOrange: 'rgba(240,129,40,0.1)',
        },
        contrastThreshold: 3,
        tonalOffset: 0.2,
        text: {
            primary: '#484848',
            disabled: '#AAAAAA',
            superDarkGrey: '#333333', // dialog: content text
        },
        // divider: "rgba(0, 0, 0, 0.12)",
        background: {
            // paper: "#fff",
            // default: "#fafafa"
        },
        action: {
            mediumGrey: 'rgba(72, 72, 72, 0.08)', // buttons: bg on hover when default or outlined
            lightgrey: '#d6d6d6', // toggle switch: disabled, buttons: outlined&container
            silver: '#CACACA', // toggle switch: hover
            dimGrey: '#b3b3b3', // radio buttons: hover, toggle switch: track
            lightsteelblue: 'bbcaea', // breadcrumbs: '&:visited'
            // Button variants:
            darkBlue: '#3d61aa', // '&:active'
            lightblue: '#6c8ed3', // '&:hover'
            darkOrange: '#bf5f00', // '&:active'
            lightOrange: '#EE9B49', // '&:hover'
            darkGreen: '#3f9140', // '&:hover'
            lightGreen: '#73c473', // '&:active'
        },
    },
    props: {},
    shadows: [
        'none',
        '0px 1px 3px 0px rgba(0,0,0,0.2),0px 1px 1px 0px rgba(0,0,0,0.14),0px 2px 1px -1px rgba(0,0,0,0.12)',
        '0px 1px 5px 0px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 3px 1px -2px rgba(0,0,0,0.12)',
        '0px 1px 8px 0px rgba(0,0,0,0.2),0px 3px 4px 0px rgba(0,0,0,0.14),0px 3px 3px -2px rgba(0,0,0,0.12)',
        '0px 2px 4px -1px rgba(0,0,0,0.2),0px 4px 5px 0px rgba(0,0,0,0.14),0px 1px 10px 0px rgba(0,0,0,0.12)',
        '0px 3px 5px -1px rgba(0,0,0,0.2),0px 5px 8px 0px rgba(0,0,0,0.14),0px 1px 14px 0px rgba(0,0,0,0.12)',
        '0px 3px 5px -1px rgba(0,0,0,0.2),0px 6px 10px 0px rgba(0,0,0,0.14),0px 1px 18px 0px rgba(0,0,0,0.12)',
        '0px 4px 5px -2px rgba(0,0,0,0.2),0px 7px 10px 1px rgba(0,0,0,0.14),0px 2px 16px 1px rgba(0,0,0,0.12)',
        '0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)',
        '0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)',
        '0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)',
        '0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)',
        '0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)',
        '0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)',
        '0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)',
        '0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)',
        '0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)',
        '0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)',
        '0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)',
        '0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)',
        '0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)',
        '0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)',
        '0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)',
        '0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)',
        '0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)',
    ],
    button: {
        backgroundColor: 'black',
        borderRadius: 3,

        textButton: {
            border: 0,
            color: 'white',
            height: 48,
            padding: '0 30px',
            boxShadow: '0 3px 5px 2px rgba(255, 105, 135, .3)',
        },
    },
    typography: {
        htmlFontSize: 16,
        fontFamily: '"Open Sans Regular", sans-serif',
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightBold: 700,
        h1: {
            fontFamily: '"Open Sans Light", sans-serif',
            fontWeight: 10,
            fontSize: '95.56px',
            lineHeight: '130px',
            letterSpacing: '-1.5px',
        },
        h2: {
            fontFamily: '"Open Sans Light", sans-serif',
            fontWeight: 300,
            fontSize: '59.72px',
            lineHeight: '81px',
            letterSpacing: '-0.5px',
        },
        h3: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 400,
            fontSize: '47.39px',
            lineHeight: '65px',
            letterSpacing: '0em',
        },
        h4: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 400,
            fontSize: '33.57px',
            lineHeight: '46px',
            letterSpacing: '0.25px',
        },
        h5: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontSize: '23.69px',
            lineHeight: '32px',
        },
        h6: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 500,
            fontSize: '19.74px',
            lineHeight: '27px',
            letterSpacing: '0.25px',
        },
        subtitle1: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 400,
            fontSize: '15.8px',
            lineHeight: '24px',
            letterSpacing: '0.15px',
        },
        subtitle2: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 500,
            fontSize: '13.82px',
            lineHeight: '24px',
            letterSpacing: '0.1px',
        },
        body1: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 400,
            fontSize: '15.8',
            lineHeight: '22px',
            letterSpacing: '0.5px',
            color: 'rgba(0,0,0,0.6)',
        },
        body2: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 400,
            fontSize: '13.82px',
            lineHeight: '20px',
            letterSpacing: '0.25px',
        },
        button: {
            fontFamily: '"Open Sans Semibold", sans-serif',
            fontWeight: 600,
            fontSize: '13.82px',
            lineHeight: '16px',
            letterSpacing: '1.25px',
            textTransform: 'initial',
            color: 'rgba(0,0,0,0.87)',
        },
        caption: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '17px',
            letterSpacing: '0.41px',
            color: 'rgba(0,0,0,0.6)',
        },
        overline: {
            fontFamily: '"Open Sans Regular", sans-serif',
            fontWeight: 400,
            fontSize: '12px',
            lineHeight: '16px',
            letterSpacing: '2.03px',
            textTransform: 'uppercase',
            color: 'rgba(0,0,0,0.6)',
        },
    },
    shape: {
        borderRadius: 3,
    },
    transitions: {
        easing: {
            easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
            easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
            easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
            sharp: 'cubic-bezier(0.4, 0, 0.6, 1)',
        },
        duration: {
            shortest: 150,
            shorter: 200,
            short: 250,
            standard: 300,
            complex: 375,
            enteringScreen: 225,
            leavingScreen: 195,
        },
    },
    zIndex: {
        mobileStepper: 1000,
        speedDial: 1050,
        appBar: 1100,
        drawer: 1200,
        modal: 1300,
        snackbar: 1400,
        tooltip: 1500,
    },
};

export default {
    ...theme,
    overrides: {
        //---------------------------------------BUTTONS---------------------------------------
        MuiButton: {
            //default css
            root: {
                color: theme.palette.text.primary,
                height: '30px',
                margin: '5px',
                minWidth: '25px',
                fontFamily: theme.typography.button.fontFamily,
                fontSize: theme.typography.button.fontSize,
            },
            // Text Button
            text: {
                backgroundColor: 'none',
                borderRadius: 1,
                border: 0,
                color: theme.palette.text.primary,
                padding: '0px 20px',
                '&:hover': {
                    backgroundColor: 'transparent',
                },
                '&:active': {
                    backgroundColor: 'transparent',
                },
            },
            textSizeLarge: {
                height: '42px',
                padding: '0px 20px',
            },
            // Outlined Button - Default
            outlined: {
                border: '1px solid ' + theme.palette.action.lightgrey,
                color: theme.palette.text.primary,
                padding: '0px 20px',
                '&:hover': {
                    borderColor: theme.palette.text.lightgrey,
                    backgroundColor: theme.palette.action.mediumGrey,
                },
                '&:active': {
                    boxShadow: '',
                    borderColor: theme.palette.action.darkGrey,
                    backgroundColor: theme.palette.action.lightgrey,
                },
                // Outlined Button - Warning
                '&.warning': {
                    color: theme.palette.text.primary,
                    borderColor: theme.palette.action.darkOrange,
                    '&:hover': {
                        backgroundColor: theme.palette.action.darkGrey,
                    },
                    '&:active': {
                        boxShadow: '',
                        backgroundColor: theme.palette.action.lightgrey,
                    },
                },
                // Outlined Button - medium Size
                '&.mediumSize': {
                    height: '36px',
                },
                //-----------------------------------MENU BUTTON---------------------------------------
                '&.menuButton': {
                    height: '30px',
                    width: '109px',
                    border: '1px solid #D6D6D6',
                    backgroundColor: '#F9F9F9',
                    fontSize: '13.8px',
                    letterSpacing: '1.25px',
                    lineHeight: '19px',
                    textAlign: 'center',
                },
                //------------------------------------------------------------------------------------
            },
            // Outlined Button - Primary
            outlinedPrimary: {
                color: theme.palette.text.primary,
                borderColor: theme.palette.primary.main,
                '&:hover': {
                    borderColor: theme.palette.primary.main,
                    backgroundColor: theme.palette.action.mediumGrey,
                    boxShadow: '',
                },
                '&:active': {
                    boxShadow: '',
                    backgroundColor: theme.palette.action.lightgrey,
                },
                // Outlined Button - Primary - Medium Size
                '&.mediumSize': {
                    height: '36px',
                },
            },
            // Outlined Button - Success
            outlinedSecondary: {
                borderColor: theme.palette.action.darkGreen,
                color: theme.palette.text.primary,
                '&:hover': {
                    borderColor: theme.palette.action.darkGreen,
                    backgroundColor: theme.palette.action.mediumGrey,
                    boxShadow: '',
                },
                '&:active': {
                    boxShadow: '',
                    backgroundColor: theme.palette.action.lightgrey,
                },
                // Outlined Button - Success - Medium Size
                '&.mediumSize': {
                    height: '36px',
                },
            },
            // Outlined Button - Success - Large Size
            outlinedSizeLarge: {
                height: '42px',
            },
            // Contained Button - Default
            contained: {
                backgroundColor: theme.palette.primary.superLightGrey,
                color: theme.palette.text.primary,
                boxShadow: '',
                border: '1px solid ' + theme.palette.action.lightgrey,
                '&:hover': {
                    borderColor: theme.palette.action.lightgrey,
                    backgroundColor: theme.palette.action.mediumGrey,
                    boxShadow: '',
                },
                '&:active': {
                    boxShadow: '',
                    borderColor: theme.palette.action.mediumGrey,
                    backgroundColor: theme.palette.action.lightgrey,
                },
                // Contained Button - Warning
                '&.warning': {
                    backgroundColor: theme.palette.warning.main,
                    color: theme.palette.common.white,
                    borderColor: theme.palette.action.darkOrange,

                    '&:hover': {
                        backgroundColor: theme.palette.action.lightOrange,
                        boxShadow: '',
                    },
                    '&:active': {
                        boxShadow: '',
                        backgroundColor: theme.palette.action.darkOrange,
                    },
                },
                // Contained Button - Medium Size
                '&.mediumSize': {
                    height: '36px',
                },
                // Icon Button
                '&.iconButton': {
                    width: '25px',
                },
            },
            // Contained Button - Primary
            containedPrimary: {
                backgroundColor: theme.palette.primary.main,
                border: '1px solid' + theme.palette.action.darkBlue,

                '&:hover': {
                    borderColor: theme.palette.action.darkBlue,
                    backgroundColor: theme.palette.action.lightblue,
                    boxShadow: '',
                },
                '&:active': {
                    boxShadow: '',
                    backgroundColor: theme.palette.action.darkBlue,
                },
                // Contained Button - Primary - mediumSize
                '&.mediumSize': {
                    height: '36px',
                },
            },
            // Contained Button - Success
            containedSecondary: {
                backgroundColor: theme.palette.success.main,
                border: '1px solid' + theme.palette.action.darkGreen,

                '&:hover': {
                    borderColor: theme.palette.action.darkGreen,
                    backgroundColor: theme.palette.action.lightGreen,
                    boxShadow: '',
                },
                '&:active': {
                    boxShadow: '',
                    backgroundColor: theme.palette.action.darkGreen,
                },
                // Contained Button - Success - Medium Size
                '&.mediumSize': {
                    height: '36px',
                },
            },
            // Contained Button - Large Size
            containedSizeLarge: {
                height: '42px',
                padding: '0px 20px',
                fontFamily: theme.typography.button.fontFamily,
                fontSize: theme.typography.button.fontSize,
            },
        },
        // Group buttons
        MuiButtonGroup: {
            grouped: {
                margin: '0px',
                marginTop: '10px',
                marginLeft: '0px',
            },
        },
        MuiFormHelperText: {
            root: {
                marginTop: '3px',
                fontSize: '11px',

                '&.Mui-error': {
                    padding: '0',
                    fontSize: '10px',
                    fontFamily: 'Open Sans Semibold Regular',
                    fontWeight: '400',
                    letterSpacing: '0.5px',
                },
            },
        },
        //-----------------------------------DATE PICKER---------------------------------------
        MuiIconButton: {
            root: {
                borderRadius: '',
                color: theme.palette.icon.main,
                padding: '2px',
                '&:hover': {
                    backgroundColor: theme.palette.primary.noneBackground,
                },
            },
            colorPrimary: {
                '&:hover': {
                    backgroundColor: theme.palette.primary.noneBackground,
                },
            },
        },
        MuiPickersCalendarHeader: {
            dayLabel: {
                color: theme.palette.text.primary,
                opacity: '50%',
            },
            switchHeader: {
                marginTop: '-30px',
            },
        },
        MuiPickersToolbarButton: {
            toolbarBtn: {
                height: '10px',
                width: '47px',
                marginBottom: '3px',
            },
        },
        MuiPickersBasePicker: {
            pickerView: {
                maxWidth: '301px',
                minWidth: '301px',
                minHeight: '330px',
                maxHeight: '330px',
                height: '330px',
                width: '301px',
            },
        },
        MuiToolbar: {
            regular: {
                minHeight: '20px',
            },
        },
        MuiPickersToolbar: {
            toolbar: {
                height: '30px',
                minHeight: '30px',
                minWidth: '207px',
                maxWidth: '207px',
                width: '207px',
                backgroundColor: theme.palette.common.white,
                marginRight: '27px',
                marginTop: '8px',
            },
        },
        MuiPickersTimePickerToolbar: {
            separator: {
                color: theme.palette.text.disabled,
                margin: '0 0px -9px 0px',
                height: '66px',
            },
            hourMinuteLabel: {
                marginLeft: '32px',
                marginRight: '-7px',
            },
            ampmSelection: {
                paddingTop: '39px',
                marginLeft: '38px',
                marginRight: '-42px',
            },
        },
        MuiPickersToolbarText: {
            toolbarBtnSelected: {
                color: theme.palette.text.primary,
                fontSize: '50px',
                marginTop: '-40px',
                marginBottom: '-30px',
            },
            //not selected
            toolbarTxt: {
                color: theme.palette.text.disabled,
                fontSize: '50px',
                marginTop: '-40px',
                marginBottom: '-30px',
            },
        },
        MuiPickersDay: {
            hidden: {
                opacity: '20%',
            },
            daySelected: {
                '&.MuiIconButton-root': {
                    '&:hover': {
                        backgroundColor: theme.palette.primary.main,
                    },
                },
            },
            current: {
                color: theme.palette.primary.main,
            },
        },
        //Date picker
        MuiFormControl: {
            root: {
                width: '300px',
                height: '48px',
                marginBottom: '12px',
            },
        },
        MuiInputAdornment: {
            '&.svg.MuiSvgIcon-root': {
                marginRight: '-5px',
            },
        },
        MuiFormLabel: {
            root: {
                color: theme.palette.primary.grey,
                fontSize: '13px',
                fontFamily: theme.typography.button.fontFamily,
            },
        },
        MuiInput: {
            underline: {
                '&:before': {
                    content: '',
                },
                '&:after': {
                    content: '',
                },
            },
        },
        //General Typography
        MuiTypography: {
            body1: {
                color: theme.palette.primary.grey,
                fontFamily: theme.typography.body1.fontFamily,
                fontSize: '12px',
                lineHeight: '17px',
            },
            h6: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
            },
            colorTextSecondary: {
                '&.dialogTextColor': {
                    color: theme.palette.text.superDarkGrey,
                },
                fontSize: theme.typography.body2.fontSize,
            },
            // BreadCrumbs
            colorInherit: {
                '&.breadcrumb': {
                    color: theme.palette.primary.main,
                },
                '&.breadcrumbCurrent': {
                    color: theme.palette.primary.grey,
                    '&:hover': {
                        textDecoration: 'none',
                    },
                },
                '&.customLink': {
                    fontSize: '13px',
                    fontFamily: 'Open Sans Regular',
                    color: theme.palette.primary.main,
                    '&:active': {
                        color: theme.palette.text.primary,
                    },
                    '&:visited': {
                        color: theme.palette.action.lightsteelblue,
                    },
                },
            },
        },
        //Style for inputs on all project
        MuiInputBase: {
            root: {
                color: theme.palette.text.primary,
                height: '24px',
                width: '265px',
                fontFamily: 'Open Sans Regular',
                fontSize: '12px',
                border: '1px solid' + theme.palette.action.silver,
                borderRadius: '3px',
                '&:active': {
                    borderColor: theme.palette.primary.main,
                },
                '&.Mui-focused': {
                    borderColor: theme.palette.primary.main,
                },
            },
            input: {
                marginLeft: '6px',
                '&:active': {
                    borderColor: theme.palette.primary.main,
                },
            },
        },
        //General class for icons
        MuiSvgIcon: {
            root: {
                marginRight: '7px',
                width: '16px',
                height: '16px',
            },
            colorPrimary: {
                fill: 'currentColor',
                color: '',
                '&.iconDefault': {
                    marginRight: '0px',
                    marginLeft: '0px',
                },
                '&.iconLarge': {
                    marginRight: '0px',
                    marginLeft: '0px',
                    width: '20px',
                    height: '20px',
                },
                '&.informationIcon': {
                    color: theme.palette.primary.main,
                },
                '&.errorIcon': {
                    color: theme.palette.error.main,
                },
                '&.warningIcon': {
                    color: theme.palette.warning.main,
                },
                '&.successIcon': {
                    color: theme.palette.success.main,
                },

                '&.surfaceMenuIcon': {
                    fill: theme.palette.common.white,
                },
                '&.menuIcon': {
                    margin: '0px',
                    color: '#8D8D8D',
                    width: '16px',
                    height: '16px',
                    marginRight: '6px',
                    marginLeft: '4px',
                },
                '&.tooltipIcon': {
                    marginRight: 0,
                    width: '20px',
                    height: '20px',
                },
            },
        },
        //-----------------------------RADIO BUTTONS----------------------------------
        MuiRadio: {
            root: {
                color: theme.palette.action.lightgrey,
                '&:hover': {
                    color: theme.palette.action.dimGrey,
                },
            },
            colorPrimary: {
                '&.Mui-checked': {
                    '&:hover': {
                        backgroundColor: ' rgb(0,0,0,0) !important',
                    },
                },
            },
        },
        MuiFormControlLabel: {
            root: {
                backgroundColor: 'none',
                padding: '20px',

                '&.radioButton': {
                    padding: '3px',
                },
                '&.radioButtonPlacement': {
                    height: '41px',
                    width: '100px',
                    padding: '0px',
                },
            },
            label: {
                '&.Mui-disabled': {
                    color: theme.palette.disabled.main,
                },
            },
        },
        //-----------------------------CHECKBOX----------------------------------
        MuiCheckbox: {
            root: {
                color: theme.palette.action.lightgrey,
                '&:hover': {
                    color: '#b3b3b3',
                },
                '&.MuiCheckbox-colorPrimary.Mui-checked': {
                    '&:hover': {
                        backgroundColor: theme.palette.primary.noneBackground,
                    },
                },
                '&.MuiCheckbox-colorPrimary.Mui-disabled': {
                    color: theme.palette.action.lightgrey,
                },
            },
        },
        //----------------------------------BREADCRUMB--------------------------------------
        PrivateBreadcrumbSeparator: {
            root: {
                marginLeft: '2px',
                color: theme.palette.text.primary,
            },
        },
        //-----------------------MENU------------------------------------------------------
        MuiMenu: {
            paper: {
                marginTop: '3px',
                boxShadow: '0 0 4PX 0 rgba(0,0,0,0.1)',
                backgroundColor: '#FFFFFF',
                borderRadius: '4px',
                width: '135px',
                border: '1px solid #E6E8ED',
            },
        },
        MuiMenuItem: {
            root: {
                color: '#494949',
                fontFamily: 'Open Sans Regular',
                fontSize: '13px',
                lineHeight: '18px',
                paddingLeft: '8px',
                paddingTop: '6px',
                height: '25px',
            },
        },
        MuiList: {
            padding: {
                paddingTop: '4px',
                paddingBottom: '8px',
            },
        },
        MuiListItem: {
            button: {
                '&:hover': {
                    backgroundColor: '#eeeeee',
                },
            },
        },
        //------------------------------------SWITCH--------------------------------------
        MuiSwitch: {
            colorSecondary: {
                '&.MuiSwitch-colorSecondary.Mui-checked + .MuiSwitch-track': {
                    backgroundColor: theme.palette.action.lightgrey,
                },
                '&.MuiSwitch-colorSecondary.Mui-disabled + .MuiSwitch-track': {
                    backgroundColor: theme.palette.action.lightgrey,
                    opacity: 1,
                },
            },
            colorPrimary: {
                '&.MuiSwitch-colorPrimary.Mui-checked': {
                    '&:hover': {
                        backgroundColor: theme.palette.primary.noneBackground,
                        opacity: 1,
                    },
                },
            },
            // styles of the component whole container
            root: {
                width: '80px',
                height: '40px',
                opacity: 1,
                '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                    opacity: 1,
                },
                '&.MuiSwitch-switchBase-40.Mui-checked + .MuiSwitch-track-48': {
                    opacity: 1,
                },
                '&:hover': {
                    '& .MuiSwitch-track': {
                        backgroundColor: theme.palette.action.silver,
                    },
                },
            },
            track: {
                width: '48px',
                height: '24px',
                borderRadius: '50px',
                opacity: 1,
                backgroundColor: theme.palette.action.dimGrey,
            },
            // toggle thumb
            thumb: {
                width: '18px',
                height: '18px',
                marginLeft: '8px',
                marginTop: '6px',
                color: theme.palette.common.white,
            },
            // styles applied on size="small" option
            sizeSmall: {
                width: '50px',
                height: '30px',
                '& .MuiSwitch-track': {
                    width: '32px',
                    height: '16px',
                },
                '& .MuiSwitch-thumb': {
                    width: '12px',
                    height: '12px',
                    marginTop: '5px',
                    marginLeft: '5px',
                },
            },
        },
        //-----------------------------SURFACES----------------------------------
        MuiAppBar: {
            root: {
                height: '65px',
                '& .MuiButton-root': {
                    color: theme.palette.common.white,
                },
                '& .MuiButtonBase-root': {
                    margin: '0 20px',
                },
                '& .MuiIconButton-root': {
                    height: '32px',
                    width: '32px',
                    padding: '0',
                    '& .MuiIconButton-label': {
                        height: '32px',
                        width: '32px',
                        '& .MuiSvgIcon-root': {
                            height: '32px',
                            width: '32px',
                            '& path': {
                                height: '32px',
                                width: '32px',
                            },
                        },
                    },
                },
                '& .right': {
                    marginLeft: 'auto',
                    marginRight: 0,
                },
            },
        },
        //-----------------------------DIALOG----------------------------------
        MuiDialogTitle: {
            root: {
                border: '1px solid' + theme.palette.action.lightgrey,
                fontSize: '26px',
                backgroundColor: theme.palette.primary.superLightGrey,
                '&.dialogTitleColor': {
                    color: theme.palette.primary.grey,
                },
                '&.defaultDialogTitleBg': {
                    backgroundColor: theme.palette.primary.superLightGrey,
                },
                '&.informationDialogTitleBg': {
                    backgroundColor: theme.palette.primary.infoBlue,
                },
                '&.errorDialogTitleBg': {
                    backgroundColor: theme.palette.error.errorPink,
                },
                '&.warningDialogTitleBg': {
                    backgroundColor: theme.palette.warning.warningLightOrange,
                },
                '&.successDialogTitleBg': {
                    backgroundColor: theme.palette.success.successLightGreen,
                },
            },
        },
        MuiDialogContent: {
            root: {
                borderRight: '1px solid' + theme.palette.action.lightgrey,
                borderLeft: '1px solid' + theme.palette.action.lightgrey,
                minHeight: '124px',
                padding: '20px 24px',
            },
        },
        MuiDialogActions: {
            root: {
                '&.dialogActionsBgColor': {
                    backgroundColor: theme.palette.primary.superLightGrey,
                },
                border: '1px solid' + theme.palette.action.lightgrey,
            },
        },
        //-----------------------------PROGRESS----------------------------------
        MuiCircularProgress: {
            colorPrimary: {
                color: '#4872C8',
                '&.inputProgress': {
                    marginRight: '8px',
                },
            },
        },
        //-----------------------------TOOLTIP----------------------------------
        MuiTooltip: {
            tooltip: {
                backgroundColor: theme.palette.primary.main,
                fontSize: theme.typography.caption.fontSize,
                lineHeight: theme.typography.caption.lineHeight,
                maxWidth: '300px',
                minHeight: '100px',
                textAlign: 'justify',
                padding: '10px 10px 10px 10px',
            },
            arrow: {
                color: theme.palette.primary.main,
            },
        },
    },
};
